import React from 'react'
import Link from 'gatsby-link'

import Albums from '../components/albums'

const IndexPage = () => (
  <div>
    {/* <h1 className="fw5 sans-serif">Hi people</h1>
    <p>Welcome to your new Gatsby site.</p>
    <p>Now go build something great.</p>
    <Link to="/page-2/">Go to page 2</Link> */}
    <Albums />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js